import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import "./faq.scss";
import useTheme from "../../components/useTheme/useTheme";
import { faqData } from "../../components/Data/faqData";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const { theme } = useTheme();

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className={`faq ${theme === "dark" ? "dark_mode--theme-styles" : ""}`}>
      <div className="faq__container">
        <div className="faq__grid">
          {/* Left Column */}
          <div className="faq__left-column">
            <div className="faq__left-content">
              <h1
                className={`faq__title ${theme === "dark" ? "text-white" : ""}`}
              >
                Frequently Asked Questions
              </h1>
              <p
                className={`faq__subtitle ${
                  theme === "dark" ? "dark_mode_text_muted--theme-styles" : ""
                }`}
              >
                Answers to most common questions
              </p>
            </div>
          </div>

          {/* Right Column */}
          <div className="faq__items">
            {faqData.map((item, index) => (
              <div
                key={index}
                className="faq__item"
                style={{
                  borderColor: theme === "dark" ? "#ffffff4f" : "",
                }}
              >
                <button
                  onClick={() => toggleAccordion(index)}
                  className="faq__question-button"
                >
                  <h3 className="faq__question-text">{item.question}</h3>
                  <div
                    className={`faq__icon ${
                      openIndex === index ? "faq__icon--open" : ""
                    }`}
                    style={{
                      filter: theme === "dark" ? "invert(1)" : "",
                    }}
                  >
                    {openIndex === index ? (
                      <Minus size={24} />
                    ) : (
                      <Plus size={24} />
                    )}
                  </div>
                </button>

                <div
                  className={`faq__answer ${
                    openIndex === index
                      ? "faq__answer--open"
                      : "faq__answer--closed"
                  }`}
                >
                  {item.answer.text && (
                    <p
                      className="faq__answer-text"
                      dangerouslySetInnerHTML={{ __html: item.answer.text }}
                    />
                  )}
                  {/* {item.answer.text && (
                    <p className="faq__answer-text" >{item.answer.text}</p>
                  )} */}
                  {item.answer.list && (
                    <ul className="faq__answer-list">
                      {item.answer.list.map((li, i) => (
                        <li
                          key={i}
                          style={{
                            listStyleType: "disc",
                          }}
                        >
                          {li}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
